import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M20 12L5 12M10 7L5 12L10 17" vectorEffect="non-scaling-stroke" />
	</SVG>
);
